import React, { useEffect, useState, useMemo } from 'react';
import { Bubble, Select } from 'tea-component';
import { useIntl } from 'umi';
import classnames from 'classnames';
import TipContext from '@home/components/TipContextComponents/TipContext';
import { useFilterOptionList } from '@/pages/intelligence/hooks/useFilterOptionList';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const segmentTooltip = (text: string, tooltip: string) => {
  return (
    <Bubble
      dark
      content={
        <>
          <span>{tooltip}</span>
        </>
      }
    >
      <div className={`segment-bubble-text`}>{text}</div>
    </Bubble>
  );
};

export default function SelectContext(props: any) {
  const {
    className,
    AWidth,
    tips,
    value: defaultValue,
    onConfirm,
    locale,
    segmentType = 'DIGITAL_SEGEMENT',
    listHeight = 234,
  } = props;
  // console.log('SelectContext', props);
  const { formatMessage } = useIntl();
  const defaultValueCur = useMemo(() => {
    switch (segmentType) {
      case filterKeyMap.REGION_SEGMENT:
        return 'global';
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}A`:
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}B`:
      case 'ENGAGELEVEL_SEGEMENT':
        return '2h';
      case 'DIGITAL_SEGEMENT':
      default:
        return 'All';
    }
  }, [segmentType]);

  const [segmentVal, setSegmentVal] = useState(defaultValue || defaultValueCur);
  useEffect(() => {
    setSegmentVal(defaultValue || defaultValueCur);
  }, [defaultValue]);

  const {
    digitalSegmentFilterOptions,
    engageLevelSegmentFilterOptions,
    regionSegmentFilterOptions,
  } = useFilterOptionList({
    formatMessage,
    segmentTooltip,
  });

  const optionsCur = useMemo(() => {
    switch (segmentType) {
      case filterKeyMap.REGION_SEGMENT:
        return regionSegmentFilterOptions;
      case 'ENGAGELEVEL_SEGEMENT':
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}A`:
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}B`:
        return engageLevelSegmentFilterOptions;
      case 'DIGITAL_SEGEMENT':
      default:
        return digitalSegmentFilterOptions;
    }
  }, [segmentType, locale]);

  const btnNameCur = useMemo(() => {
    switch (segmentType) {
      case filterKeyMap.REGION_SEGMENT:
        return 'dbi_region_segment_btnname';
      case 'ENGAGELEVEL_SEGEMENT':
        return 'dbi_filter_segment_engagement_two_b_level';
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}A`:
        return 'dbi_filter_segment_engagement_two_a';
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}B`:
        return 'dbi_filter_segment_engagement_two_b';
      case 'DIGITAL_SEGEMENT':
      default:
        return 'dbi_filter_segment';
    }
  }, [segmentType]);

  const widthCur = useMemo(() => {
    switch (segmentType) {
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}A`:
      case `${filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO}B`:
      case filterKeyMap.REGION_SEGMENT:
        return 240;
      case 'ENGAGELEVEL_SEGEMENT':
        return 240;
      case 'DIGITAL_SEGEMENT':
      default:
        return 198;
    }
  }, [segmentType]);

  return (
    <Select
      className={classnames(
        'select-item engagement-level-select',
        className,
        tips ? 'digital-segment-tips' : '',
      )}
      style={{ width: widthCur }}
      appearance="button"
      options={optionsCur}
      value={segmentVal}
      listHeight={listHeight}
      matchButtonWidth
      onChange={(value) => {
        setSegmentVal(value);
        if (onConfirm instanceof Function) {
          onConfirm(value);
        }
      }}
      button={() => (
        <div className="dbi-select-button">
          <div className="select-button-text">{formatMessage({ id: btnNameCur })}</div>
          {tips && (
            <div style={{ marginRight: 6, lineHeight: 0 }}>
              <TipContext Performance="left" AWidth={AWidth} tipText={tips} />
            </div>
          )}
          <span className="select-button-desc">
            {
              optionsCur.filter((e) => {
                return e.value == segmentVal;
              })[0]?.text
            }
          </span>
        </div>
      )}
    />
  );
}
